import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getTransportistaGatewayBaseUrl } from '../base/url.gateway';
import { TransportistaSessionStorage } from '../jwt/session.storage';

/**
 * Añade `Authorization: Bearer` a las peticiones cuya URL sea del API Gateway transportista.
 */
@Injectable()
export class GatewayBearerInterceptor implements HttpInterceptor {
  constructor(private readonly session: TransportistaSessionStorage) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const base = getTransportistaGatewayBaseUrl();
    if (!request.url.startsWith(base)) {
      return next.handle(request);
    }
    const token = this.session.getToken();
    if (!token) {
      return next.handle(request);
    }
    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }
    return next.handle(
      request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }
}
